import { Component } from 'react';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import { history } from '../../../../store';

class CarouselItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemClassName: ''
    };
  }

  componentDidMount() {
    this.calculateFade();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isScrolled !== this.props.isScrolled) {
      this.calculateFade();
    }
  }

  getRef = (instance) => {
    this.ref = instance;
  }

  calculateFade = () => {
    if (this.ref) {
      const {
        width, left
      } = this.ref.getBoundingClientRect();
      const { outerWidth } = window;
      const halfWidth = (width / 2);
      const center = left + halfWidth;

      if (center + halfWidth <= outerWidth && center - halfWidth >= 0) {
        this.setState({ itemClassName: 'overlay-visible' });
      } else if (center + halfWidth < outerWidth || center - halfWidth > 0) {
        this.setState({ itemClassName: 'overlay-partly-visible' });
      }
    }
  }

  render() {
    const { id, image, name } = this.props;
    const { itemClassName } = this.state;
    const isMobileScreen = window.innerWidth <= 768;

    return (
      <div>
        <div ref={this.getRef} className="carousel-item">
          <Link
            to={`/article/${id}`}
            style={{ opacity: isMobileScreen ? 1 : 0 }}
            className={`overlay ${itemClassName}`}
          >
            <Truncate lines={2} ellipsis={<span>...</span>}>
              {name}
            </Truncate>
          </Link>
          <img src={image} alt={name} />
        </div>
        {!isMobileScreen && (
          <div
            className="carousel-item-title"
            onClick={() => {
              history.push(`/article/${id}`);
            }}
          >
            {name}
          </div>
        )}
      </div>

    );
  }
}

export default CarouselItem;
